import { AbstractStore } from "../common/AbstractStores";
import Dispatcher from "../common/dispatcher";
import Actions from "./ImpiantiClimaActions";
import { ImpiantoClimaDto } from "../generated";

class ImpiantiClimaStore extends AbstractStore<ImpiantoClimaDto> {
    constructor() {
        super(x => x.id.toString());
        Dispatcher
            .onfunction(Actions.get, result => this.updateOrAdd(result))
            .onfunction(Actions.add, result => this.add(result))
            .onfunction(Actions.update, result => this.updateOrAdd(result))
            .onfunction(Actions.delete, result => result.deleteOk ? this.delete(result.impiantoId.toString()) : () => { })
    }

    public use = (id: number) => this.useWithAction(() => Actions.get(id), id?.toString() ?? null);


}

export default new ImpiantiClimaStore()
